import { DatePipe, DecimalPipe, PercentPipe, registerLocaleData } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesPartialsModule } from 'src/app/components/pages-partials/pages-partials.module';
import {
  HttpTranslateFactory,
  LangSetResolveFactory,
  LANG_SET,
} from 'src/app/helpers';
import {
  NgbDateParserFormatter,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { LocalizedDatePipe } from 'src/app/pipes/localized-date.pipe';
//import { AppInsightsService } from 'src/app/services/app-insights.service';
import { ApplicationResourcesService } from 'src/app/services/application-resources/application-resources.service';
import { AuthService } from 'src/app/services/auth.service';
import { ChangePasswordService } from 'src/app/services/change-password.service';
import { CurrencyService } from 'src/app/services/currency.service';
import { NavigateService } from 'src/app/services/navigate.service';
import { SearchService } from 'src/app/services/search.service';
import { ValidationService } from 'src/app/services/validation.service';
import { VClassService } from 'src/app/services/vclass.service';
import { WorkOrderService } from 'src/app/services/workorder.service';
import { SearchResultsComponent } from 'src/app/pages/search/results/results.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AccountGuard } from './guards/account.guard';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { FailoverInterceptor } from './interceptor/failover.interceptor';
import { UnauthorizedInterceptor } from './interceptor/unauthorized.interceptor';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { NoAuthLayoutModule } from './layouts/noauth-layout/noauth-layout.module';
import { BlankLayoutModule } from './layouts/blank-layout/blank-layout.module';
import { DynamicDashboardComponent } from './pages/dynamic-dashboard/dynamic-dashboard.component';
import { DynamicList2Component } from './pages/dynamic-list-2/dynamic-list-2.component';
import { DashboardRedirectComponent } from './pages/home/dashboard.component';
import { DashboardModule } from './pages/home/dashboard/dashboard.module';
import { CustomNgbDateParserFormatter } from './providers/custom-ngb-date-parser-formatter';
// import { GlobalErrorHandler } from './providers/global-error.provider';
import { DynamicDataListModule } from 'src/app/components/dynamic-data-list/dynamic-data-list.module';
import { DynamicFormPageComponent } from './pages/dynamic-form-page/dynamic-form-page.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { WORKITEM_PRELOADER_TOKEN } from 'src/app/services/workitem-preload.service';
import { VrmValidatePreloadService } from './pages/workorders/workitems/vrm-validate-preload.service';
import { ClaimService } from 'src/app/services/claim.service';
import { EsbService } from 'src/app/services/esb.service';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import { LocalizedNumberPipe } from 'src/app/pipes/localized-number.pipe';
import localeDa from '@angular/common/locales/da';
import localeSe from '@angular/common/locales/se';

registerLocaleData(localeDa, 'da');
registerLocaleData(localeSe, 'se');

@NgModule({ declarations: [
        AppComponent,
        SearchResultsComponent,
        DashboardRedirectComponent,
        DynamicList2Component,
        DynamicDashboardComponent,
        DynamicFormPageComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        AdminLayoutModule,
        NoAuthLayoutModule,
        BlankLayoutModule,
        CustomPipesModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpTranslateFactory,
                deps: [HttpClient],
            },
        }),
        PagesPartialsModule,
        DashboardModule,
        DynamicDataListModule,
        ComponentsModule,
        NgbDropdownModule], providers: [
        AuthService,
        NavigateService,
        EsbService,
        ChangePasswordService,
        PercentPipe,
        SearchService,
        AccountGuard,
        VClassService,
        WorkOrderService,
        CurrencyService,
        ValidationService,
        //AppInsightsService,
        {
            provide: JWT_OPTIONS,
            useValue: JWT_OPTIONS,
        },
        JwtHelperService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthorizedInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FailoverInterceptor,
            multi: true,
        },
        // {
        //   provide: ErrorHandler,
        //   useClass: GlobalErrorHandler,
        // },
        {
            provide: LANG_SET,
            useFactory: LangSetResolveFactory,
        },
        ApplicationResourcesService,
        provideAppInitializer(() => {
        const initializerFn = (initializeApplicationResources)(inject(ApplicationResourcesService));
        return initializerFn();
      }),
        {
            provide: DatePipe,
            useClass: LocalizedDatePipe,
        },
        {
            provide: DecimalPipe,
            useClass: LocalizedNumberPipe,
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline', floatLabel: 'always' }
        },
        { provide: NgbDateParserFormatter, useClass: CustomNgbDateParserFormatter },
        { provide: WORKITEM_PRELOADER_TOKEN, useClass: VrmValidatePreloadService, multi: true, deps: [ClaimService] },
        provideHttpClient(withInterceptorsFromDi()),
    ] })

export class AppModule {}

export function initializeApplicationResources(applicationResourcesService: ApplicationResourcesService) {
 
  return async () => await firstValueFrom(applicationResourcesService.initialize(), { defaultValue: undefined });
}
